@use '../../css/base.scss';

:host {
  display: block;
  width: 100%;
  word-wrap: break-word;
  min-width: 280px;
  overflow: auto;
  position: relative;
}

.search_section {
  padding: calc(var(--pv-size-base) * 4);
  border-bottom: 1px solid var(--pv-color-gray-4);
}

.input_search {
  height: calc(var(--pv-size-base) * 8);
  width: 100%;
  outline: none;
  background-color: var(--pv-color-gray-1);
  padding: 0 calc(var(--pv-size-base) * 2);
  border: 1px solid var(--pv-color-gray-7);
  border-radius: 4px;
  transition: background-color 200ms ease 0s, color 200ms ease 0s, border-color 200ms ease 0s;
  &::placeholder {
    color: var(--pv-color-gray-9);
  }
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;

  td, th {
    border-bottom: 1px solid var(--pv-color-gray-4);
    vertical-align: top;
    text-align: left;

    &:first-child {
      padding-right: 0;
      width: calc(var(--pv-size-base) * 10);
    }
    &:last-child {
      padding-left: 0;
      width: calc(var(--pv-size-base) * 10);
    }
  }

  th {
    padding: calc(var(--pv-size-base) * 2) calc(var(--pv-size-base) * 4);

    &.col_action {
      padding: 0;
    }
  }

  td {
    padding: calc(var(--pv-size-base) * 4);
  }

  tr {
    &.m_expanded {
      background: var(--pv-color-gray-1);

      > td {
        border-bottom: none;
      }
    }

    &.expanded_summary {
      background: var(--pv-color-gray-1);

      table {
        table-layout: initial;

        td {
          border-bottom: none;
          padding: calc(var(--pv-size-base) * 2);

          &:first-child {
            width: 200px;
          }

          &:last-child {
            width: auto;
          }
        }
      }
    }
  }
}

.button_table_cell {
  margin-top: -3px;
}

.status_wrapper {
  text-align: center;
  height: calc(var(--pv-size-base) * 16);
  vertical-align: middle;
}

.modal_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  animation: fadeIn 200ms;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal_backdrop {
  background: var(--pv-color-black);
  z-index: -1;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.5;
}

.modal_container {
  background: var(--pv-color-white);
  width: 100%;
  display: flex;
  max-height: calc(100% - 60px);
  flex-direction: column;
  margin: calc(var(--pv-size-base) * 6);
  position: relative;
  outline: none;
  box-shadow: var(--pv-shadow-dark-hight);
  overflow: hidden;
  border: 0px;
  padding: 0px;
  max-width: 640px;
  border-radius: 4px;
}

.modal_header {
  padding: calc(var(--pv-size-base) * 3) calc(var(--pv-size-base) * 4);
  display: flex;
  flex: 0 0 auto;
  -webkit-box-pack: justify;
  justify-content: space-between;
  gap: calc(var(--pv-size-base) * 2);
  border-bottom: 1px solid var(--pv-color-gray-5);
}

.modal_content {
  flex: 1 1 auto;
  overflow: auto;
}

:host([data-mobile-screen-view="true"]) {
  table, tbody, tr, td {
    display: block;
    width: 100% !important;
    padding: 0;
    border: none;
  }

  thead {
    display: none;
  }

  table {
    tr {
      padding: calc(var(--pv-size-base) * 2) 0;
    }

    .expanded_summary {
      padding: 0;
    }

    .certificate_row {
      border-bottom: 1px solid var(--pv-color-gray-5);
      padding: calc(var(--pv-size-base) * 2) calc(var(--pv-size-base) * 4);
    }

    .certificate_row_actions {
      padding-top: calc(var(--pv-size-base) * 6);

      td {
        display: flex;
        justify-content: right;
        gap: calc(var(--pv-size-base) * 4);
      }
    }
  }

  .button_table_cell {
    margin-top: 0;
  }
}
